import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faBullseye,
    faStopwatch,
    faGem,
    faFire,
    faSpa,
    faIcons,
    faBullhorn,
    faCodeBranch,
    faMountain,
    faTheaterMasks,
    faBriefcase,
    faPenFancy,
    faCalculator,
    faBrain,
    faSignOutAlt,
    faDesktop,
    faUserEdit,
    faPlusCircle,
    faChevronDown,
    faArrowLeft,
    faArrowRight,
    faTimes,
    faExpandArrowsAlt,
    faStar as faStarSolid,
    faPhone,
    faEnvelope,
    faTimesCircle,
    faInfoCircle,
    faCheck,
    faAngleDown,
    faAngleUp,
    faUser,
    faTachometerAlt,
    faClipboardList,
    faCubes,
    faFile,
    faPrint,
    faHeart,
    faExclamationTriangle,
    faChevronUp,
    faMobileAlt,
    faEllipsisH,
    faCheckSquare,
    faVenus,
    faMars,
    faTransgender,
    faGlobe,
    faSquare,
    faChevronRight,
    faQuestion
} from '@fortawesome/free-solid-svg-icons';

import {
    faStar,
    faStarHalf,
    faFilePdf
} from '@fortawesome/free-regular-svg-icons';

import {
    faFacebookF,
    faLinkedinIn
} from '@fortawesome/free-brands-svg-icons';

// add imported icons to global library to make them available wherever the FontAwesomeIcon component is imported
library.add(
    faEnvelope,
    faPhone,
    faStopwatch,
    faGem,
    faFire,
    faBullhorn,
    faCodeBranch,
    faMountain,
    faTheaterMasks,
    faBriefcase,
    faPenFancy,
    faCalculator,
    faBrain,
    faSignOutAlt,
    faUserEdit,
    faPlusCircle,
    faChevronDown,
    faArrowLeft,
    faArrowRight,
    faTimes,
    faExpandArrowsAlt,
    faDesktop,
    faStarSolid,
    faStar,
    faStarHalf,
    faFacebookF,
    faLinkedinIn,
    faTimesCircle,
    faInfoCircle,
    faCheck,
    faAngleDown,
    faAngleUp,
    faUser,
    faTachometerAlt,
    faClipboardList,
    faCubes,
    faFile,
    faPrint,
    faHeart,
    faExclamationTriangle,
    faChevronUp,
    faFilePdf,
    faMobileAlt,
    faEllipsisH,
    faCheckSquare,
    faSquare,
    faVenus,
    faMars,
    faTransgender,
    faGlobe,
    faChevronRight,
    faQuestion,
    faBullseye,
    faIcons,
    faSpa
);
